import React, { useState, useEffect } from "react";
import "./style.css";

const SadEmojiBackground = ({ children }) => {
  const [emojis, setEmojis] = useState([]);

  useEffect(() => {
    const generatedEmojis = generateRandomEmojis(50);
    setEmojis(generatedEmojis);
  }, []);

  return (
    <div className="background">
      {emojis.map((emoji, index) => (
        <div
          key={index}
          className={`emoji ${emoji.style} animated`}
          style={{
            ...emoji.position,
            animationDelay: emoji.animationDelay,
            fontSize: emoji.size,
          }}
        >
          {emoji.icon}
        </div>
      ))}
      {children}
    </div>
  );
};

const generateRandomEmojis = (count) => {
  const emojis = [];
  const styles = [
    "rotate-90",
    "rotate-180",
    "rotate-360",
    "rotate-110",
    "scaleX-180",
    "scaleX-90",
  ];

  for (let i = 0; i < count; i++) {
    let style = "";
    if (i % 5 === 0) {
      style = "rotate-90"; // Rotate every 5th emoji
    } else {
      style = styles[Math.floor(Math.random() * styles.length)];
    }
    const size =
      i % 7 === 0
        ? `${Math.floor(Math.random() * 200) + 100}px`
        : `${Math.floor(Math.random() * 50) + 10}px`; // Larger size every 7th emoji
    const top = `${Math.random() * 100}%`;
    const left = `${Math.random() * 100}%`;
    const animationDelay = `${Math.random() * 6}s`; // Adjust animation delay as needed

    emojis.push({
      icon: getRandomSadEmoji(), // Get a random sad emoji
      style,
      size,
      position: { top, left },
      animationDelay,
    });
  }

  return emojis;
};

const getRandomSadEmoji = () => {
  const sadEmojis = ["😞", "😢", "😭", "😔", "🙁"]; // Add more sad emojis if needed
  return sadEmojis[Math.floor(Math.random() * sadEmojis.length)];
};

export default SadEmojiBackground;
